import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";
import { useResourceQueries } from "@exonn/base";
import { ResourceEnum } from "src/constants/constants.ts";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import { LettersPanel } from "src/admin/epost-letters/LettersPanel.tsx";
import { RefreshButton } from "src/admin/exonn-common/components/ListRefresh.tsx";
import { useListRefresh } from "src/admin/exonn-common/useListRefresh.ts";
import {
  refreshingList,
  toolbar,
} from "src/admin/exonn-common/components/listStyles.ts";

/** Вкладка «Per Post» у документа и заказа: кнопка обновления и список писем. */
export const LettersTabPage = (props: ComponentProps<typeof LettersPanel>) => {
  const { t } = useTranslation(TranslationNamespaceEnum.EpostLetters);
  const queries = useResourceQueries();
  const { refreshing, refresh } = useListRefresh(
    queries.lists({ resource: ResourceEnum.EpostLetter }),
  );

  return (
    <div style={{ padding: 15 }}>
      <div css={toolbar}>
        <RefreshButton
          label={t("refresh")}
          refreshing={refreshing}
          onClick={refresh}
        />
      </div>
      <div css={refreshing && refreshingList}>
        <LettersPanel {...props} />
      </div>
    </div>
  );
};
